<template>
    <div class="payment-container" v-show="visible && isPaymentStepActive">
        <card class="p-0 rounded-lg">
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('online_payment.payment_heading') }}
            </h4>
            <div
                role="tabpanel"
                aria-labelledby="headingClients"
                data-parent="#event-accordion"
            >
                <div class="panel-body" id="choose-user-body-booking">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="alert alert-danger mb-6" v-if="payment_error">
                                <i class="zmdi zmdi-alert-triangle mr-3 alert-ico"></i>
                                <span>{{ payment_error }}</span>
                            </div>

                            <div class="flex flex-column sm:flex-col-reverse space-y-6 sm:space-y-reverse">
                                <div class="well mb-0 shadow-none">
                                    <form v-on:submit.prevent="pay" id="payment-frm" class="form-horizontal" role="form">
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div id="card-element" class="card-box"></div>
                                            </div>
                                        </div>

                                        <button type="submit" class="btn btn-block btn-lg btn-custom collapsed" v-if="!loading && membershipPlan">
                                            <i class="zmdi zmdi-check"></i>
                                            <span class="m-l-10">{{ trans('online_payment.submit') }} {{ totalMembershipPriceToPayNowFormatted }} / {{ trans(`apps.memberships.frequencies.${membershipPlan.frequency}`) }}</span>
                                        </button>

                                        <div class="btn btn-block btn-lg btn-custom btn-payment-loading"
                                             v-if="loading">
                                            <div class="preloader"></div>
                                        </div>

                                        <p class="text-center secure-payment m-t-5">
                                            <small>
                                                <span class="zmdi zmdi-lock m-r-5" aria-hidden="true"></span>
                                                {{ trans('online_payment.secure_payments_new') }} <a :href="trans('online_payment.easypay_website_url')"
                                                                                                     target="_blank">EasyPay</a> {{ trans('global.and') }} <a
                                                href="https://stripe.com" target="_blank">Stripe</a>
                                            </small>
                                        </p>
                                    </form>
                                </div>
                                <div class="payment-box" v-if="membershipPlan">
                                    <form class="form-horizontal" role="form">

                                        <h5 class="m-t-0">{{ trans('apps.online_courses.payment_info_heading') }}</h5>

                                        <hr>

                                        <div class="form-group m-b-0">
                                            <label class="col-sm-4 control-label m-b-0">{{ trans('online_booking.receipt_name') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">{{ membershipPlan.name }}</div>
                                            </div>
                                        </div>

                                        <div class="form-group m-b-10">
                                            <label class="col-sm-4 control-label">{{ trans('settings.amount') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">
                                                    {{ totalMembershipPriceToPayNowFormatted }} / {{ trans(`apps.memberships.frequencies.${membershipPlan.frequency}`) }}
                                                    <br>
                                                    <small>{{ renewalDescription }}</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group m-b-10" v-if="discountMoneyUsed">
                                            <label class="col-sm-4 control-label">{{ trans('global.discount') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">
                                                    - {{ discountMoneyUsedFormatted }}
                                                    ({{ discount_code.code }}
                                                    {{ discount_code.type == 'percentage' ? discount_code.value + '%' : membershipPlan.currency + ' ' + discount_code.value }})
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group m-b-10" v-if="giftcardMoneyUsed">
                                            <label class="col-sm-4 control-label">{{ trans('giftcards.title') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">
                                                    - {{ giftcardMoneyUsedFormatted }} ({{ giftcard.name }})
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <previous-button class="p-6 pt-0" :previous-step-id="getPreviousStepId" />
        </card>
    </div>

</template>

<script>
    import { http } from '@/system/http';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import Card from '@/online_booking/new/components/common/Card';
    import StepCounter from '@/online_booking/new/components/common/StepCounter';
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import Events from '@/core/Events';

    export default {
        data() {
            return {
                visible: false,
                loading: false,
                slug: null,
                publishable_key: Config.get('app.STRIPE_PUBLISHABLE_KEY'),
                dataFrm: null,
                membershipPlan: null,
                payment_error: '',
                stripe: false,
                stripe_card: false,
                stripe_payment_intent_secret: false,
            }
        },

        mounted() {
            this.slug = this.$route.params.slug;

            this.$event_bus.$on('LoadMembershipData', (data) => {
                this.membershipPlan = data.membership_plan;

                this.visible = true
            });

            this.$event_bus.$on('membershipPayment', (data) => {
                if ($(window).width() < 500) {
                    setTimeout(function(){
                        $('html, body').animate({scrollTop:$('#buy-membership-plan-container').offset().top});
                    }, 250);
                };
                this.dataFrm = data.dataFrm;
                this.membershipPlan = data.data.membership_plan;
                this.stripe_payment_intent_secret = data.data.payment_intent_secret;
                this.setCurrentStep('payment');
            });

            this.$event_bus.$on('ConfirmMembershipShowed', () => {
                if (this.totalMembershipPriceToPayNow <= 0) {
                    this.visible = false;
                } else {
                    this.visible = true;
                }
            });

            $(document).ready(function(){
                $('[data-toggle="tooltip"]').tooltip();
            });

            if (typeof Stripe !== 'undefined') {
                this.stripe = Stripe(this.publishable_key, { locale: moment_locale });

                var style = {
                    base: {
                        fontSize: '16px',
                        color: "#505458",
                    }
                };

                this.stripe_card = this.stripe.elements().create('card', {style: style});
                this.stripe_card.mount('#card-element');
            }
        },

        watch: {
            visible (newValue) {
                this.setPaymentStepVisibility(newValue);
            },
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep']),
            ...mapGetters('OnlineBooking', ['getPreviousStepId', 'totalStepCount', 'currentStepNumber']),

            totalMembershipPriceToPayNow() {
                if (this.membershipPlan) {
                    return this.membershipPlan.price_in_cents_with_vat - this.discountMoneyUsed - this.giftcardMoneyUsed;
                }

                return 0;
            },

            totalMembershipPriceToPayNowFormatted() {
                if (this.membershipPlan) {
                    return this.membershipPlan.currency + ' ' + (this.totalMembershipPriceToPayNow / 100).toFixed(2);
                }

                return 0;
            },

            giftcard() {
                return this.$store.getters.giftcard;
            },

            giftcardMoneyUsed() {
                if (!this.membershipPlan || !this.giftcard || this.giftcard.money_left <= 0) {
                    return 0;
                }

                let amountUsed = Math.min(this.membershipPlan.price_in_cents_with_vat - this.discountMoneyUsed, this.giftcard.money_left);

                return amountUsed;
            },

            giftcardMoneyUsedFormatted() {
                if (this.membershipPlan) {
                    return `${this.membershipPlan.currency} ${(this.giftcardMoneyUsed / 100).toFixed(2)}`;
                }
            },

            discount_code() {
                return this.$store.getters.discount_code;
            },

            discountMoneyUsed() {
                if (!this.discount_code) {
                    return 0;
                }

                let amountUsed = 0;

                if (this.discount_code.type == 'percentage') {
                    amountUsed = Math.round(this.membershipPlan.price_in_cents_with_vat * (this.discount_code.value / 100));
                } else {
                    amountUsed = Math.min(this.discount_code.value * 100, this.membershipPlan.price_in_cents_with_vat);
                }

                return amountUsed;
            },

            discountMoneyUsedFormatted() {
                return `${this.membershipPlan.currency} ${(this.discountMoneyUsed / 100).toFixed(2)}`;
            },

            isPaymentStepActive () {
                return this.currentStep === 'payment';
            },

            renewalDescription() {
                const membershipIntervals = {
                    weekly: 'week',
                    monthly: 'month',
                    yearly: 'year'
                }

                const date = moment().add(1, membershipIntervals[this.membershipPlan.frequency])

                return trans('apps.memberships.renewal_description', {
                    price: this.totalMembershipPriceToPayNowFormatted,
                    interval: trans(`apps.memberships.renewal_intervals.${this.membershipPlan.frequency}`),
                    renewal_date: this.$filters.format_date(date, 'YYYY-MM-DD')
                })
            },
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep', 'setPaymentStepVisibility']),

            pay() {
                this.loading = true;
                this.stripe.handleCardPayment( this.stripe_payment_intent_secret, this.stripe_card, {} ).then( (response) => this.stripeResponseHandler(response) );
            },

            stripeResponseHandler(response) {
                this.payment_error = '';

                if (response.error) {
                    this.payment_error = this.getStripeErrorMessage(response.error.message, response.error.code);
                    this.loading = false;
                } else {
                    this.payMembershipPlan(response.paymentIntent);
                }
            },

            payMembershipPlan(payment_intent) {
                this.dataFrm.append('payment_intent_id', payment_intent.id);
                this.dataFrm.append('payment_intent_payment_method', payment_intent.payment_method);

                if (this.discount_code) {
                    this.dataFrm.append('discount_code_id', this.discount_code.id);
                }

                if (this.giftcard) {
                    this.dataFrm.append('giftcard_id', this.giftcard.id);
                }

                http.post('/subscription/' + this.slug + '/pay', this.dataFrm)
                    .then(({ data }) => {
                        this.$event_bus.$emit('infoMembershipAdded', data.data);

                        this.$event_bus.$emit(Events.MembershipSubscription.Purchased);

                        this.loading = false;
                    })
                    .catch(({ errorBag }) => {
                        this.loading = false;
                        this.$setErrorBag(errorBag);
                    });
            },

            getStripeErrorMessage(message, code) {
                if (code == "invalid_expiry_month" || code == "invalid_expiry_year") {
                    return trans('online_payment.card_date_error');
                }

                if (code == "incorrect_number" || code == 'invalid_number') {
                    return trans('online_payment.card_number_error');
                }

                if (code == 'invalid_cvc' || code == 'incorrect_cvc') {
                    return trans('online_payment.card_cvc_error');
                }

                if (code == 'expired_card') {
                    return trans('online_payment.card_expired');
                }

                if (code == 'card_declined') {
                    return trans('online_payment.card_declined');
                }

                if (code == 'processing_error' || code == 'rate_limit') {
                    return trans('online_payment.card_error');
                }

                return message;
            },
        },

        components: {
            Card,
            StepCounter,
            PreviousButton,
        },
    };

</script>

<style>
    .payment-cards img {
        width: 50px;
        height: auto;
        margin-right: 10px;
    }
</style>
